import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { Product } from "@lib/types/Billing";

export const apiGetProducts = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/billing-product` });
  return API.get<PaginationType<Product>>(url);
};

export const apiGetProduct = async (customerId: string) => {
  const url = `/billing-product/${customerId}`;
  return API.get<Product>(url);
};

export const apiAddProduct = async (data: Product) => {
  return API.post<Product>(`/billing-product`, data);
};

export const apiDeleteProduct = async (data: Product) => {
  return API.delete<null>(`/billing-product/${data.id}`);
};

export const apiUpdateProduct = async (data: Product) => {
  const { id, ...rest } = data;
  return API.patch<Product>(`/billing-product/${id}`, rest);
};
